<div class="row">
  <div class="col table__statistics dense__table">
    <h6 class="lateral__bar primary mb-3">Otras campañas enviadas al mismo cliente</h6>
    <div class="table-responsive-md">
      <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table data-tables w-100">
        <thead>
          <tr>
            <th width="252px">Campaña</th>
            <th width="252px">Tipo</th>
            <th width="252px">Medio</th>
            <th width="252px">Fecha Envío/Llamada</th>
            <th width="252px">Grupo PV/Concesionario</th>
            <th width="92px">Opciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let elem of model">
            <td class="text-start">{{ elem.Campaign }}</td>
            <td class="text-start">{{ elem.Type }}</td>
            <td class="text-start">{{ elem.Media }}</td>
            <td class="text-start">{{ elem.SendDate }}</td>
            <td class="text-start">{{ elem.Origin }}</td>
            <td class="text-center"> <button *ngIf="elem.Media!='TELEMARKETING'" (click)="showHtml(elem)" type="button" class="btn-option-eye" ngbTooltip="Ver Creatividad" placement="left"></button></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>